import axios from 'axios';

import TimeTrackingActions from 'ontraccr-common/lib/timeTracking/state/timeTracking.actions';

import { request } from '../helpers/requests';
import Analytics from '../helpers/Analytics';

export default TimeTrackingActions({ request, axios, Analytics });
